import {
  Button,
  Dialog,
  DialogActions,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  withStyles,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import useStyles from 'views/Products/products.styles'
import ChangeReasonStep from './ChangeReasonStep'
import ChangeValidationStep from './ChangeValidationStep'
import { adminChangeOrderStatus } from 'services/orders/OrdersClient.services'
import { STATUS_COMPLETED_ID } from 'constants/ordersContants'
import useCustomDialogAlert from 'components/useCustomDialogAlert'

const CircleConnector = withStyles({
  alternativeLabel: {
    top: 20,
    left: 'calc(-50% + 30px)',
    right: 'calc(50% + 30px)',
  },
  active: {
    '& $line': {
      borderColor: '#6064FF',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#6064FF',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector)

const STEPS = ['Razón de cambio', 'Confirmación']

const ProductStatusChange = ({ open, onClose, modificationData, onConfirm }) => {
  const classes = useStyles()
  const [activeStep, setActiveStep] = useState(0)
  const [reason, setReason] = useState('')
  const showDialogAlert = useCustomDialogAlert()
  const [loading, setLoading] = useState(false)

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <ChangeReasonStep
            reason={reason}
            reasonType={modificationData.statusId}
            onReasonChange={setReason}
          />
        )
      case 1:
        return (
          <ChangeValidationStep
            productName={modificationData.productName}
            currentStatus={modificationData.currentStatus}
            newStatus={
              modificationData.statusId === STATUS_COMPLETED_ID ? 'Completado' : 'Cancelado'
            }
            reason={reason}
          />
        )
      default:
        return <div>Unknown step</div>
    }
  }

  const handleConfirm = async () => {
    setLoading(true)
    const { orderId, orderDetailIds, statusId } = modificationData
    try {
      const response = await adminChangeOrderStatus({
        orderId,
        orderDetailIds,
        statusId,
        reason,
      })

      await onConfirm()
      showDialogAlert(
        true,
        '¡Cambio exitoso!',
        `¡El estado ha sido modificado con éxito!`,
        'Cerrar',
        '',
        true
      )
      onClose(response)
    } catch {
      showDialogAlert(
        true,
        '¡Advertencia!',
        `Ha ocurrido un error al intentar cambiar el estado del producto.`,
        'Cerrar'
      )
      onClose()
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    onClose()
  }
  useEffect(() => {
    if (open) {
      setActiveStep(0)
      setReason('')
    }
  }, [open])

  if (!open) {
    return null
  }

  return (
    <Dialog open={open} keepMounted onClose={handleClose} fullWidth maxWidth="md">
      <Stepper activeStep={activeStep} alternativeLabel connector={<CircleConnector />}>
        {STEPS.map((label) => (
          <Step key={label}>
            <StepLabel
              classes={{
                label: classes.labelStepLabel,
                active: classes.activeStepLabel,
                completed: classes.completedStepLabel,
              }}
              StepIconProps={{
                classes: {
                  root: classes.rootStepIcon,
                  text: classes.text,
                  active: classes.active,
                  completed: classes.completed,
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {getStepContent(activeStep)}
        <DialogActions>
          <Button disabled={activeStep === 0} onClick={handleBack} className={classes.backButton}>
            Atras
          </Button>
          <Button
            variant="contained"
            className={classes.btnBackgroundErrorPriceSmall}
            onClick={handleClose}
          >
            Cancelar
          </Button>

          {activeStep === STEPS.length - 1 ? (
            <Button
              className={classes.btnNewProductsmall}
              onClick={handleConfirm}
              disabled={loading}
            >
              Confirmar
            </Button>
          ) : (
            <Button
              className={classes.btnNewProductsmall}
              onClick={handleNext}
              disabled={reason.length <= 4}
            >
              Siguiente
            </Button>
          )}
        </DialogActions>
      </div>
    </Dialog>
  )
}

ProductStatusChange.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  modificationData: PropTypes.shape({
    orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    orderDetailIds: PropTypes.array,
    statusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    productName: PropTypes.string,
    currentStatus: PropTypes.string,
  }).isRequired,
}

export default ProductStatusChange
